import React from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";
import { capitalizeFirstLetter } from "src/_config";

interface MemberInfoSectionProps {
  userSelector: any;
  formatPhoneNumber: (phone?: string | null, phoneCode?: string) => string;
  formatDate: (dateStr?: string) => string;
}

const MemberInfoSection: React.FC<MemberInfoSectionProps> = ({ userSelector, formatPhoneNumber, formatDate }) => {
  const { t } = useTranslation("member");

  return (
    <div className="row">
      <div className="col-md-12">
        {/* Personal Information Section */}
        <div className="personal-info-card">
          <div className="personal-info-header">
            <h2 className="section-title">{t("members.profile.personalInfo.title")}</h2>
            <p className="section-subtitle">{t("members.profile.personalInfo.subtitle")}</p>
          </div>

          <div className="personal-info-content">
            <div className="info-grid">
              <div className="info-row">
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.gender")}</div>
                  <div className="field-value">
                    {/* {userSelector?.user?.gender == "no-preference"
                      ? "No Preference" */}
                    {userSelector?.user?.gender
                      ? capitalizeFirstLetter(userSelector?.user?.gender)
                      : t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.dateOfBirth")}</div>
                  <div className="field-value">{formatDate(userSelector?.user?.date_of_birth)}</div>
                </div>
              </div>

              <div className="info-row">
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.employeeCode")}</div>
                  <div className="field-value">
                    {userSelector?.user?.employee_code || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.hometown")}</div>
                  <div className="field-value">
                    {userSelector?.user?.home_town || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
              </div>

              <div className="info-row">
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.language")}</div>
                  <div className="field-value">
                    {userSelector?.user?.language || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.maritalStatus")}</div>
                  <div className="field-value">
                    {userSelector?.user?.marital_status || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
              </div>

              <div className="info-row">
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.nationality")}</div>
                  <div className="field-value">
                    {userSelector?.user?.nationality || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
                <div className="info-field">
                  <div className="field-label">{t("members.profile.personalInfo.fields.religion")}</div>
                  <div className="field-value">
                    {userSelector?.user?.religion || t("members.profile.personalInfo.notProvided")}
                  </div>
                </div>
              </div>

              {userSelector?.user?.permanent_address && (
                <div className="info-row full-width">
                  <div className="info-field">
                    <div className="field-label">{t("members.profile.personalInfo.fields.permanentAddress")}</div>
                    <div className="field-value">{userSelector?.user?.permanent_address}</div>
                  </div>
                </div>
              )}

              {userSelector?.user?.current_address && (
                <div className="info-row full-width">
                  <div className="info-field">
                    <div className="field-label">{t("members.profile.personalInfo.fields.currentAddress")}</div>
                    <div className="field-value">{userSelector?.user?.current_address}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberInfoSection;
